import { Skeleton } from 'v5/design-system/Skeleton';
import { cn } from 'v5/platform/dom/cn';
import { useSkeletonFade } from '../skeletonFade';

/** The resource pane before it is there: cover and picture, name, scopes, then label and value rows. */
export function ResourcePaneSkeleton() {
  const fade = useSkeletonFade();
  return (
    <div className="tailwind-root contents">
      <div
        aria-hidden
        className={cn('flex h-full flex-col', fade.className)}
        style={fade.style}
      >
        <Skeleton className="h-20 shrink-0 rounded-none" />
        <div className="space-y-3 px-5 pb-5">
          <Skeleton className="-mt-8 size-20 rounded-xl border-4 border-bg-default" />
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-4 w-28" />
          <div className="flex gap-2 pt-1">
            <Skeleton className="h-5 w-16" />
            <Skeleton className="h-5 w-12" />
            <Skeleton className="h-5 w-20" />
          </div>
          <div className="flex gap-2 pt-3">
            <Skeleton className="h-9 w-24" />
            <Skeleton className="h-9 w-24" />
            <Skeleton className="h-9 w-24" />
          </div>
          <Skeleton className="h-11 w-full rounded-xl" />
          {Array.from({ length: 6 }, (_, index) => (
            <div key={index} className="space-y-2 pt-3">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-4 w-40" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
